export const TYPE_LOCALIZATION_MODEL = {
  RU: 'Русский',
  EN: 'Английский',
  HY: 'Армянский',
}
